import i18next from 'i18next'
import { BasePOSTransactionType } from '@/types/transactions'

export const getPOSTransactionType = ({transactionType, operation}: BasePOSTransactionType) => {
    switch (transactionType) {
        case 'retail':
        case 'unique':
            switch (operation) {
                case 'request':
                    return i18next.t('enums:transactionTypes.AUTH')
                case 'advice':
                    return i18next.t('enums:transactionTypes.SALE')
                case 'adjustment':
                    return i18next.t('enums:transactionTypes.ADJUSTMENT')
                case 'reversal':
                    return i18next.t('enums:transactionTypes.REFUND')
            }
        case 'credit':
        case 'credit-notif':
        case 'credit-apm':
            switch (operation) {
                case 'advice':
                    return i18next.t('enums:transactionTypes.REFUND')
            }
        case 'retail-apm':
            switch (operation) {
                case 'advice':
                    return i18next.t('enums:transactionTypes.SALE')
            }
    }

    return '-'
}
